import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { useStatsApiQuery } from '../utils/query'
import { getDeviceCardTips } from '../utils/tips'

/**
 * 乘梯违规统计卡片
 *
 * @returns LiftViolationCard component
 */
export const LiftViolationCard: FC = () => {
  const { semesterInfo, timeRange, role } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()

  const apiQuery = useStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorStudentLiftAssessmentStats',
    params: {
      query: apiQuery,
    },
    options: {
      enabled: !!reflection?.usin,
    },
  })

  const { data: liftStats } = res || {}
  const getInfo = (type: 'self' | 'help') =>
    liftStats?.find((item) => item.type === type)
  const selfCount = getInfo('self')?.type_user_count ?? 0
  const helpCount = getInfo('help')?.type_user_count ?? 0

  return (
    <IndexBoardCard
      title={$t('乘梯违规统计')}
      count={liftStats?.at(0)?.total_user_count ?? 0}
      items={[
        {
          label: $t('无权限自行乘梯'),
          value: selfCount ?? 0,
        },
        {
          label: $t('携带无权限同学乘梯'),
          value: helpCount ?? 0,
        },
      ]}
      flex={1}
      type={StatsDetailsTabEnum.StudentLiftViolation}
      loading={loading}
      tips={getDeviceCardTips(role)}
      itemIconMsg={{
        name: 'Elevator',
        color: '#08CCBF',
        backgroundColor: '#E8FFFA',
      }}
    />
  )
}
